import React, { useEffect } from 'react';
import { Button } from 'antd';

const FacebookLogin = ({ appId, onFacebookLoginSuccess, onFacebookLoginFailure }) => {
  useEffect(() => {
    // Load Facebook SDK
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: appId,
        cookie: true,
        xfbml: true,
        version: 'v21.0'
      });
      window.FB.AppEvents.logPageView();
    };

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }, [appId]);

  const checkLoginState = () => {
    window.FB.getLoginStatus(function(response) {
      statusChangeCallback(response);
    });
  };

  const statusChangeCallback = (response) => {
    if (response.status === 'connected') {
      console.log('User is logged in.');
      onFacebookLoginSuccess(response.authResponse);
    } else {
      console.log('User is not logged in.');
      onFacebookLoginFailure();
    }
  };

  const handleLogin = () => {
    window.FB.login(checkLoginState, {
        scope: 'public_profile,email,instagram_basic,instagram_content_publish,pages_read_engagement,pages_manage_engagement,pages_manage_posts,pages_read_user_content,business_management',
        config_id: "911833544124254"
    });
};

  return (
    <Button  onClick={handleLogin}>Login with Facebook</Button>
  );
};

export default FacebookLogin;